import React, { useCallback, useEffect, useState, useRef } from "react";
import "./Control_Range.css";
import * as helpers from '../../../../helpers/Other_helpers';
import HorizontalBarChart from '../../../charts/HorizontalBarChart';

// var chart_labels = [];
// var chart_data = [];
// var chart_colors = [];
// var chart_keys = [];

const Control_Range = ({ filter_id, rangeValues, rangeIncrement, filterFormat, selectedValues, chartData, handleChange_min, handleChange_max }) => {

    const chart_labels = useRef([]);
    const chart_data = useRef([]);
    const chart_colors = useRef([]);
    const chart_keys = useRef([]);
    const range = useRef(null);
    const [selectedValues_UI, setSelectedValues_UI] = useState({ ...selectedValues });
    const [selectedValues_UI_input, setSelectedValues_UI_input] = useState({ ...selectedValues });
    const [rangeValues_UI, setRangeValues_UI] = useState({ ...rangeValues });
    const [hideLeftData, setHideLeftData] = useState({ left: 0, width: 0 });
    const [hideRightData, setHideRightData] = useState({ right: 0, width: 0 });

    // Convert to percentage
    const getPercent = useCallback(
        (value) => Math.round(((value - rangeValues_UI.min) / (rangeValues_UI.max - rangeValues_UI.min)) * 100),
        [rangeValues_UI.min, rangeValues_UI.max]
    );
    // Chart data
    useEffect(() => {
        if (chartData !== null) {
            console.log("!!!! CHANGE IN CHART DATA", filter_id, chartData);
            chart_labels.current = [];
            chart_data.current = [];
            chart_colors.current = [];
            chart_keys.current = Object.keys(chartData);
            chart_keys.current.sort();
            for (var i = 0; i < chart_keys.current.length; i++) {
                var floor = chart_keys.current[i];
                var ceil = (Number(chart_keys.current[i]) + rangeIncrement).toFixed(filterFormat?.prettynum || 0);
                chart_labels.current.push(filterFormat?.label + " entre " + floor + " et " + ceil + (filterFormat?.post ? " " + filterFormat?.post : ""));
                // chart_data.current.push(chart_keys.current.includes((i * rangeIncrement).toString()) ? chartData[(i * rangeIncrement).toString()] : 0);
                chart_data.current.push(chartData[chart_keys.current[i]]);
                chart_colors.current.push("rgba(211, 211, 211, 0.4)");
            }
            setBarChartData({
                labels: chart_labels.current,
                datasets: [
                    {
                        label: "Nombre de parcelles",
                        data: chart_data.current,
                        backgroundColor: chart_colors.current,
                    },
                ],
            });
            // Set Range values
            setRangeValues_UI({ min: 0, max: chart_keys.current.length - 1 });
            // Set selected values
            setSelectedValues_UI({ min: 0, max: chart_keys.current.length - 1 });
            setSelectedValues_UI_input({ ...selectedValues });
        }
    }, [chartData]);
    // Set width of the range to decrease from the left side
    useEffect(() => {
        // Update slider color
        const minPercent = getPercent(selectedValues_UI.min);
        const maxPercent = getPercent(selectedValues_UI.max);
        if (range.current) {
            range.current.style.left = `${minPercent}%`;
            range.current.style.width = `${maxPercent - minPercent}%`;
        }
        // Update hide positions
        setHideLeftData({ left: 0, width: minPercent });
        setHideRightData({ right: 0, width: (100 - maxPercent) });
        // Update chart colors
        chart_colors.current = [];
        for (var i = 0; i < chart_keys.current.length; i++) {
            var floor = parseInt(chart_keys.current[i]);
            if (selectedValues_UI.min <= i && selectedValues_UI.max >= i) {
                chart_colors.current.push("rgba(211, 211, 211, 0.8)");
            }
            else {
                chart_colors.current.push("rgba(211, 211, 211, 0.4)");
            }
        }
        console.log("!!!! CHANGE IN CHART DATA2", filter_id, chart_data.current);
        setBarChartData({
            labels: chart_labels.current,
            datasets: [
                {
                    label: "Nombre de parcelles",
                    data: chart_data.current,
                    backgroundColor: chart_colors.current,
                },
            ],
        });
    }, [selectedValues_UI, getPercent]);
    // Stick values to increment
    const getIncrementedValue_min = (value) => {
        var multiplier = filterFormat?.prettynum > 0 ? Math.pow(10, filterFormat.prettynum) : 1;
        var value_rounded = Math.floor(value * multiplier) / multiplier;
        var value_modulated = value_rounded % rangeIncrement;
        var value_incremented = value_rounded;
        if (value_modulated > 0) { value_incremented = value_rounded - value_modulated }
        value_incremented = value_incremented.toFixed(filterFormat.prettynum);
        return value_incremented
    }
    const getIncrementedValue_max = (value) => {
        var multiplier = filterFormat?.prettynum > 0 ? Math.pow(10, filterFormat.prettynum) : 1;
        var value_rounded = Math.ceil(value * multiplier) / multiplier;
        var value_modulated = value_rounded % rangeIncrement;
        var value_incremented = value_rounded;
        if (value_modulated > 0) { value_incremented = value_rounded + (rangeIncrement - value_modulated) }
        value_incremented = value_incremented.toFixed(filterFormat.prettynum);
        return value_incremented
    }
    // Handlers
    const handleSlideChange_min = (control_value) => {
        const value_UI = Math.min(Number(control_value), selectedValues_UI.max - 1);
        const value_real = getRealValueFromUIValue(value_UI);
        setSelectedValues_UI({ ...selectedValues_UI, min: value_UI });
        setSelectedValues_UI_input({ ...selectedValues_UI_input, min: value_real });
    }
    const handleSlideValidate_min = (control_value) => {
        const value_UI = Math.min(Number(control_value), selectedValues_UI.max - 1);
        const value_real = getRealValueFromUIValue(value_UI);
        const incremented_value = getIncrementedValue_min(value_real);
        const value_real_corrected = Math.min(incremented_value, selectedValues.max - rangeIncrement);
        // console.log("CHANGE MIN", control_value, value_UI, value_real, value_real_corrected);
        handleChange_min(value_real_corrected);
    }
    const handleInputChange_min = (input_value) => {
        const value_real = Number(input_value);
        const value_real_corrected = Math.min(Math.floor(Number(input_value)), selectedValues.max - rangeIncrement);
        const value_UI = getUIValueFromRealValue(value_real_corrected);
        setSelectedValues_UI_input({ ...selectedValues_UI_input, min: value_real });
        setSelectedValues_UI({ ...selectedValues_UI, min: value_UI });
    }
    const handleInputValidate_min = (input_value) => {
        const value_real = Math.min(Number(input_value), selectedValues.max - rangeIncrement);
        const incremented_value = getIncrementedValue_min(value_real);
        const value_real_corrected = Math.min(incremented_value, selectedValues.max - rangeIncrement);
        const value_UI = getUIValueFromRealValue(value_real_corrected);
        // console.log("CHANGE MIN", input_value, value_UI, value_real, value_real_corrected);
        setSelectedValues_UI_input({ ...selectedValues_UI_input, min: value_real_corrected });
        setSelectedValues_UI({ ...selectedValues_UI, min: value_UI });
        handleChange_min(value_real_corrected);
    }
    const handleSlideChange_max = (control_value) => {
        const value_UI = Math.max(Number(control_value), selectedValues_UI.min + 1);
        const value_real = getRealValueFromUIValue(value_UI);
        setSelectedValues_UI({ ...selectedValues_UI, max: value_UI });
        setSelectedValues_UI_input({ ...selectedValues_UI_input, max: value_real });
    }
    const handleSlideValidate_max = (control_value) => {
        const value_UI = Math.max(Number(control_value), selectedValues_UI.min + 1);
        const value_real = getRealValueFromUIValue(value_UI);
        const incremented_value = getIncrementedValue_max(value_real);
        const value_real_corrected = Math.max(incremented_value, selectedValues.min + rangeIncrement);
        // console.log("CHANGE MAX", control_value, value_UI, value_real, value_real_corrected);
        handleChange_max(value_real_corrected);
    }
    const handleInputChange_max = (input_value) => {
        const value_real = Number(input_value);
        const value_real_corrected = Math.max(Math.ceil(Number(input_value)), selectedValues.min + rangeIncrement);
        const value_UI = getUIValueFromRealValue(value_real_corrected);
        setSelectedValues_UI_input({ ...selectedValues_UI_input, max: value_real });
        setSelectedValues_UI({ ...selectedValues_UI, max: value_UI });
    }
    const handleInputValidate_max = (input_value) => {
        const value_real = Math.max(Math.ceil(Number(input_value)), selectedValues.min + rangeIncrement);
        const incremented_value = getIncrementedValue_max(value_real);
        const value_real_corrected = Math.max(incremented_value, selectedValues.min + rangeIncrement);
        const value_UI = getUIValueFromRealValue(value_real_corrected);
        // console.log("CHANGE MAX", input_value, value_UI, value_real, value_real_corrected);
        setSelectedValues_UI_input({ ...selectedValues_UI_input, max: value_real_corrected });
        setSelectedValues_UI({ ...selectedValues_UI, max: value_UI });
        handleChange_max(value_real_corrected);
    }

    // Transform values
    const getRealValueFromUIValue = (value_UI) => {
        return Number(chart_keys.current[value_UI]);
        // return parseInt(chart_keys.current[value_UI]);
    }
    const getUIValueFromRealValue = (value_real) => {
        var value_UI = 0;
        for (var i = 1; i < chart_keys.current.length; i++) {
            if (Number(chart_keys.current[i]) > value_real) {
                // if (parseInt(chart_keys.current[i]) > value_real) {
                value_UI = i - 1;
                break;
            }
        }
        return value_UI;
    }
    // Chart
    const [barChartData, setBarChartData] = useState({
        labels: ["Superficie", "h", "j", "k"],
        datasets: [
            {
                label: "Superficie entre X et X m²",
                data: [100, 25, 61, 87],
                backgroundColor: "#d0dee775",
                borderColor: "#F1F1F1",
                hoverBorderColor: "#F1F1F1",
                borderWidth: 0,
                hoverBorderWidth: 0
            },
        ],
    });
    const barChartOptions = {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
                position: 'bottom'
            },
        },
        scales: {
            xAxis: {
                display: false,
                stacked: true,
            },
            yAxis: {
                display: false,
                stacked: true,
                // ticks: {
                //     stepSize: 1
                // }
            }
        },
        interaction: {
            intersect: false,
            mode: 'index',
        },
    }

    return (
        <div className="rangeslider__container_main">
            <div className="rangeslider__container_chart_main">
                <div className="rangeslider__container_chart">
                    <HorizontalBarChart chartData={barChartData} chartOptions={barChartOptions} />
                </div>
                {/* <div className="rangeslider__container_chart_hide">
                    <div className="rangeslider__container_chart_hide_left" style={{ width: 'calc(' + hideLeftData.width + '% + 6px)' }}></div>
                    <div className="rangeslider__container_chart_hide_right" style={{ width: 'calc(' + hideRightData.width + '% + 6px)' }}></div>
                </div> */}
            </div>
            <div className="rangeslider__container">
                <input
                    id={"filter_" + filter_id + "_thumb_min"}
                    type="range"
                    min={rangeValues_UI.min}
                    max={rangeValues_UI.max}
                    // step={rangeIncrement}
                    step="1"
                    value={selectedValues_UI.min}
                    onChange={(event) => {
                        handleSlideChange_min(event.target.value);
                    }}
                    onMouseUp={(event) => {
                        handleSlideValidate_min(event.target.value);
                    }}
                    className="rangeslider__thumb rangeslider__thumb_left"
                />
                <input
                    id={"filter_" + filter_id + "_thumb_max"}
                    type="range"
                    min={rangeValues_UI.min}
                    max={rangeValues_UI.max}
                    // step={rangeIncrement}
                    step="1"
                    value={selectedValues_UI.max}
                    onChange={(event) => {
                        handleSlideChange_max(event.target.value);
                    }}
                    onMouseUp={(event) => {
                        handleSlideValidate_max(event.target.value);
                    }}
                    className="rangeslider__thumb rangeslider__thumb_right"
                />
                <div className="rangeslider__slider">
                    <div className="rangeslider__slider__track" />
                    <div ref={range} className="rangeslider__slider__range" />
                </div>
            </div>
            <div className="rangeslider__container_values">
                {/* <div className="rangeslider__slider__left_value">{selectedValues_UI.min}</div> */}
                {/* <div className="rangeslider__slider__right_value">{selectedValues_UI.max}</div> */}
                <div className="rangeslider__slider__left_container">
                    <div className="rangeslider__slider__left_label">
                        Valeur min :
                    </div>
                    <div className="rangeslider__slider__input_container">
                        <input className="rangeslider__slider__input" type="number" id={"filter_" + filter_id + "_input_min"} name={"filter_" + filter_id + "_input_min"} min={rangeValues.min} max={rangeValues.max} step={rangeIncrement} defaultValue={selectedValues?.min || 0} value={selectedValues_UI_input.min} onChange={(e) => { handleInputChange_min(e.target.value) }} onBlur={(e) => { handleInputValidate_min(e.target.value) }} onKeyUp={(e) => { if (e.key === "Enter") { document.getElementById("filter_" + filter_id + "_input_min").blur() } }}></input><div className="rangeslider__slider__input_unit">{filterFormat?.post || ""}</div>
                    </div>
                </div>
                <div className="rangeslider__slider__right_container">
                    <div className="rangeslider__slider__left_label">
                        Valeur max :
                    </div>
                    <div className="rangeslider__slider__input_container">
                        <input className="rangeslider__slider__input" type="number" id={"filter_" + filter_id + "_input_max"} name={"filter_" + filter_id + "_input_max"} min={rangeValues.min} max={rangeValues.max} step={rangeIncrement} defaultValue={selectedValues?.max || 10000} value={selectedValues_UI_input.max} onChange={(e) => { handleInputChange_max(e.target.value) }} onBlur={(e) => { handleInputValidate_max(e.target.value) }} onKeyUp={(e) => { if (e.key === "Enter") { document.getElementById("filter_" + filter_id + "_input_max").blur() } }}></input><div className="rangeslider__slider__input_unit">{filterFormat?.post || ""}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Control_Range;
